import './index.css'
import React from 'react';

export default (props)=> <div {...props} className={'Close-Button'}>X</div>